export const PPFullColorLogoE = "https://statics.payping.ir/Payping-logo/full%20logo/english/fullcolor/SVG/payping.svg";
export const PPFullColorLogoFa =
  "https://statics.payping.ir/Payping-logo/full%20logo/persian/fullcolor/0.5x/Asset%204%400.5x.png";
